import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IMaskModule } from 'angular-imask';
import { ContactFormComponent } from './contact-form.component';
import { ArrowIconComponent } from './input-button/arrow-icon.component';
import { InputButtonComponent } from './input-button/input-button.component';
import { InputSelectOptionsComponent } from './input-select/input-select-options.component';
import { InputSelectComponent } from './input-select/input-select.component';
import { InputTextComponent } from './input-text/input-text.component';
import { InputTextareaComponent } from './input-textarea/input-textarea.component';

@NgModule({
  declarations: [
    ContactFormComponent,
    InputTextComponent,
    InputButtonComponent,
    ArrowIconComponent,
    InputSelectComponent,
    InputSelectOptionsComponent,
    InputTextareaComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IMaskModule,
    OverlayModule,
    PortalModule,
    A11yModule
  ],
  entryComponents: [InputSelectOptionsComponent],
  exports: [ContactFormComponent]
})
export class ContactFormModule {}
